import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
})
export class BlogComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-center',
    title: 'BLOG',
    subTitle: 'Recent Blog',
  };

  List: any[] = [
    {
      img: './assets/images/about-us/02.png',
      name:  'HTML',
      time: 'September 26, 2019 ',
      title: 'Build Construction',
      desc: '“They bring to you a host of beautifully created infographics that contain the latest digital marketing ',
    },
    {
      img: './assets/images/about-us/03.png',
      name:  'Design',
      time: 'September 26, 2019 ',
      title: 'Life Lack Meaning',
      desc: 'They bring to you a host of beautifully created infographics that contain the latest digital marketing.',
    },
    {
      img: './assets/images/about-us/04.png',
      name:  'HTML',
      time: 'September 26, 2019 ',
      title: 'Construction industry',
      desc: 'They bring to you a host of beautifully created infographics that contain the latest digital marketing',
    },
    {
      img: './assets/images/about-us/05.png',
      name:  'CSS',
      time: 'September 26, 2019 ',
      title: 'Content Marketing',
      desc: 'They bring to you a host of beautifully created infographics that contain the latest digital marketing.',
    }
  ];
  constructor() { }

  ngOnInit() {
  }

}
